import * as types from './actionTypes'

export const messageReset = () => ({
    type: types.MESSAGE_RESET
})

export const messageSet = (message) => ({
    type: types.MESSAGE_SET,
    message
})
